var React = require('react');

function Groundwork (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42.069 1.69a4.498 4.498 0 00-6.352-.012 7.502 7.502 0 00-1.04 9.525l-13.82 13.82-6.364-6.364a1.5 1.5 0 00-2.121 0l-8.487 8.48c-4.687 4.688-4.687 12.288 0 16.976 4.688 4.688 12.288 4.687 16.976 0l8.484-8.486a1.5 1.5 0 000-2.122l-3.182-3.18a1.5 1.5 0 00-2.121 2.122l2.12 2.12-7.423 7.424A9.003 9.003 0 016.006 29.26l7.426-7.42 5.303 5.304-3.795 3.795a1.5 1.5 0 002.12 2.122l4.854-4.854.003-.002.003-.003 14.878-14.878a7.502 7.502 0 009.523-1.04 4.5 4.5 0 00-.01-6.344L42.07 1.69zm-4.242 2.12a1.498 1.498 0 012.12 0l4.241 4.25a1.5 1.5 0 010 2.115l-.017.017a4.5 4.5 0 11-6.474-6.252l.003-.003.105-.105.022-.021zm-2.29-1.952l-.001.001 1.082 1.039-1.079-1.042-.001.002z"}));
}

Groundwork.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Groundwork;

Groundwork.default = Groundwork;
